import { render, staticRenderFns } from "./DownloadAllAttachmentsModal.vue?vue&type=template&id=486c5f8c&"
import script from "./DownloadAllAttachmentsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadAllAttachmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports